import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Injector,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  Router,
  ActivatedRoute,
  Params
} from '@angular/router';
import { BehaviorSubject, EMPTY, timer } from 'rxjs';
import { debounce, filter, take } from 'rxjs/operators';
import { MetricsService, TRACKABLE_EVENTS } from './core/services';
import { PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { PricingModalComponent } from '@fb-tool-front/shared/components/pricing-modal/pricing-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomDialogService } from '@fb-tool-front/shared/components/dialog/dialog.component';
import { ResizeObserverDirective } from '@ng-web-apis/resize-observer';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private loading$$ = new BehaviorSubject<boolean>(true);
  public loading$ = this.loading$$.asObservable().pipe(debounce(res => (res ? timer(100) : EMPTY)));

  @ViewChild('rootResize', { static: true, read: ResizeObserverDirective })
  rootResize: ResizeObserverDirective;

  constructor(
    private router: Router,
    private metricsService: MetricsService,
    private route: ActivatedRoute,
    private customDialogService: CustomDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  ngOnInit(): void {
    this.metricsService.trackEvent(TRACKABLE_EVENTS.visit());
    /* Stripe query param processing */
    this.route.queryParams.pipe(filter((params: Params) => params.fromStripe)).subscribe(() => {
      this.customDialogService
        .open(new PolymorpheusComponent(PricingModalComponent, this.injector), {
          closeable: true,
          withoutHeading: true,
          customButtons: true
        })
        .pipe(untilDestroyed(this))
        .subscribe();

      this.router.navigate([], {
        queryParams: {
          fromStripe: null
        },
        queryParamsHandling: 'merge'
      });
    });
    /* Stripe query param processing*/
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading$$.next(true);
    }

    if (event instanceof NavigationEnd) {
      this.loading$$.next(false);
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading$$.next(false);
    }

    if (event instanceof NavigationError) {
      this.loading$$.next(false);
    }
  }
}
